

import { ReactFlowProvider } from '@xyflow/react';

import { NarrativeGraphViewInner } from './NarrativeGraphViewInner';

import type { NarrativeGraphViewProps } from './types';

/**
 * Narrative Graph View component with ReactFlowProvider wrapper.
 * This is the main export that should be used by consumers.
 *
 * The ReactFlowProvider is required for hooks like useAddNodeOnDrop
 * and useDeleteMiddleNode to work correctly.
 */
export function NarrativeGraphView(props: NarrativeGraphViewProps) {
  return (
    <ReactFlowProvider>
      <NarrativeGraphViewInner {...props} />
    </ReactFlowProvider>
  );
}

// Alias for backward compatibility
export { NarrativeGraphView as NarrativeGraphViewWithProvider };

export default NarrativeGraphView;
